import { render, staticRenderFns } from "./test-touch.vue?vue&type=template&id=14c5d900&"
import script from "./test-touch.js?vue&type=script&lang=js&"
export * from "./test-touch.js?vue&type=script&lang=js&"
import style0 from "./test-touch.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports